<template>
    <div class="slider-item-content"
        :data-position="position"
        :data-snap="snap"
        :data-video="video ? true : false"
        :data-url="item.url" 
        :style="`border-width: ${borderWidth}px;`"
        @click.ctrl="() => { return true; }" 
        @click.exact="fnGotoUrl && fnGotoUrl(item.url)" 
        v-observe-visibility="{
            callback: visibilityChanged,
            intersection:{
                rootMargin: `${width}px 0px ${height}px 0px`
            }
        }">
        <Mub :blockProduct="item">
            <a :href="item.url" class="w-100 h-100 slider-item-href" :aria-label="item.name">&nbsp;</a>
            <Video v-if="video" :video="video" class="h-100 slider-item-video" :pause="!inViewPort" :start-time="seek" ></Video>
            <BlockImage 
                :classNames="'w-100 h-100'" 
                :classNamesBox="'w-100 h-100'" 
                :isScrolled="alreadyAppear || zoomDetails"
                :image="item.image" 
                :imageSrcSet="item.image2x" 
                :width="width" 
                :height="height"
                :title="item.name">
            </BlockImage>
            <BlockShadow 
                v-if="isHoverandZoomActivated" 
                :name="item.name" 
                :extra-field="item.subtitle"
                :url="item.url" 
                :priceCrossed="item.priceCrossed" 
                :price="item.price" />
            <BlockShadowDesc 
                v-if="!isHoverandZoomActivated" 
                :name="item.name" 
                :url="item.url"
                :priceCrossed="item.priceCrossed" 
                :price="item.price" 
                :description="item.description" />
            <BlockLabel 
                v-if="item.label && inViewPort" 
                :label="item.label"
                :timerOnZoom="isHoverandZoomActivated"
                :timeCounter="item.timeCounter" />
            <BlockLikes 
                v-if="item.likes" 
                :likes="item.likes" 
                :rank="item.ranking"
                :label-rank="item.rankingLabel" 
                :ranking-css-class="item.rankingCssClass"
                :isDesktop="isDesktop">
            </BlockLikes>
            <div v-if="(numeration && item.numeration)" class="slider-numeration">
                {{item.numeration}}
            </div>
        </Mub>
    </div>
</template>
<script>
import BlockImage from '../../Common/Partials/BlockImage';
import BlockShadow from '../../Common/Partials/BlockShadow.vue';
import BlockShadowDesc from '../../Common/Partials/BlockShadowDesc.vue';
import BlockLabel from './BlockLabel';
import BlockLikes from '../../Common/Partials/BlockLikes';
import Common from '../../Common/Partials/BlockItem';
import Video from '@/components/Muffin/Video/Component';
import Mub from '@/components/Mub';

export default{
    extends: Common,
    components:{
        BlockImage,
        BlockShadow,
        BlockShadowDesc,
        BlockLabel,
        BlockLikes,
        Video,
        Mub
    },
    computed:{
        seek(){
            return this.item?.videoTime ?? 0;
        }
    }
}
</script>